// extracted by mini-css-extract-plugin
export default {"ImageButton":"imageButton_ImageButton__o2RlD"};